export class form_data{
    sepal_length = 5.1;
    sepal_width = 5.4;
    petal_length = 1.6;
    petal_width = 0.2;

}